// https://gitlab.awx.im/growth/webapp-container/-/blob/master/app/src/utils/analytics/google.ts
import ReactGA4 from 'react-ga4';
import { airTracker } from './airTracker';
import i18n from './i18n';
import { GoogleAnalytics } from '@airwallex/google-analytics-helper';

export const initGA = (): void => {
  const ga4Id = window?.airwallex?.ga4Id ?? 'G-J1TGSTQ102';
  if (typeof window !== 'undefined' && !window.GA4_INITIALIZED) {
    ReactGA4.initialize(ga4Id);
    window.GA4_INITIALIZED = true;
  }
};

export function getDefaultParams() {
  return {
    event_timestamp: Date.now(),
    is_ga_custom_event: true,
    page_title: 'Digital Invoice',
    page: location.href,
    language: i18n.language,
    account_id: airTracker?.commonData?.sellerId,
    country_code: airTracker?.commonData?.countryCode,
    airtracker_session_id: airTracker?.commonData?.sessionId,
  };
}

export const pageView: GoogleAnalytics['pageView'] = (location = window.location) => {
  if (window.GA4_INITIALIZED) {
    ReactGA4.set({ page: location.href });
    ReactGA4.send({ hitType: 'pageview', ...getDefaultParams(), page: location.href });
  }
};

export const eventGa4: GoogleAnalytics['eventGa4'] = (name: string, params?: Record<string, unknown>) => {
  if (window.GA4_INITIALIZED) {
    ReactGA4.event(name, {
      ...getDefaultParams(),
      ...params,
    });
  }
};

// After GA4 is fully adopted, this function equivalent to GA4's set custom dimensions on session level
// The set command lets you define parameters that will be associated with every subsequent event on the page
// https://developers.google.com/tag-platform/gtagjs/reference#set
export const set: GoogleAnalytics['set'] = (obj) => {
  if (window.GA4_INITIALIZED) {
    ReactGA4.set(obj);
  }
};

export const timing: GoogleAnalytics['timing'] = (category, variable, value, label): void => {
  if (window.GA4_INITIALIZED) {
    ReactGA4.send({ hitType: 'timing', category, variable, value, label, ...getDefaultParams() });
  }
};
